"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _reactDom = require("react-dom");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _ComponentWithWindowListeners = _interopRequireDefault(require("UIComponents/mixins/ComponentWithWindowListeners"));

var _CompanyLogo = _interopRequireDefault(require("MeetingsLib/components/decorative/CompanyLogo"));

var _CompactBookingPage = _interopRequireDefault(require("MeetingsLib/components/page/CompactBookingPage"));

var _FullSizeBookingPage = _interopRequireDefault(require("MeetingsLib/components/page/FullSizeBookingPage"));

var _TroubleshootModeToggle = _interopRequireDefault(require("MeetingsLib/components/header/TroubleshootModeToggle"));

var _AutoSubmitSelector = require("MeetingsLib/selectors/AutoSubmitSelector");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _LegalConsentFormSelectors = require("MeetingsLib/selectors/LegalConsentFormSelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _TroubleshootingSelectors = require("MeetingsLib/selectors/TroubleshootingSelectors");

var BookActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/BookActions"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var UIActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/UIActions"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserMessage = _interopRequireDefault(require("MeetingsLib/models/UserMessage"));

var _BookingLifecycle = _interopRequireDefault(require("MeetingsLib/models/BookingLifecycle"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var COMPACT_BREAKPOINT = 632;
var Booking = (0, _createReactClass.default)({
  mixins: [_ComponentWithWindowListeners.default],
  propTypes: {
    // passed
    avatar: _propTypes.default.string,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    headline: _propTypes.default.string,
    hideLogo: _propTypes.default.bool,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    submittingMeeting: _propTypes.default.bool,
    DatePickerMarker: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    EmailFormMarker: _propTypes.default.func.isRequired,
    // loaded
    bookingLifecycle: _propTypes.default.instanceOf(_BookingLifecycle.default).isRequired,
    formState: _propTypes.default.instanceOf(_FormState.default),
    legalConsentEnabled: _propTypes.default.bool,
    legalConsentResponses: _propTypes.default.instanceOf(_immutable.List),
    canSubmitInitialPropertyForm: _propTypes.default.bool,
    embedded: _propTypes.default.bool.isRequired,
    forceMobile: _propTypes.default.bool,
    isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
    canTroubleshoot: _propTypes.default.bool,
    troubleshooting: _propTypes.default.bool.isRequired,
    toggleTroubleshootMode: _propTypes.default.func.isRequired,
    shouldShowEmailForm: _propTypes.default.bool,
    userMessage: _propTypes.default.instanceOf(_UserMessage.default)
  },
  getInitialState: function getInitialState() {
    return {
      compact: false,
      showedEmailForm: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var forceMobile = this.props.forceMobile;

    if (forceMobile || window.innerWidth < COMPACT_BREAKPOINT) {
      this.setState({
        compact: true
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    (0, _UsageTracker.track)('meetingsLibViewScreen', {
      stage: 'book'
    });
    this.handleResizeIFrame();
  },
  markShowedEmailForm: function markShowedEmailForm() {
    this.setState({
      showedEmailForm: true
    });
  },
  shouldShowEmailForm: function shouldShowEmailForm() {
    return this.props.shouldShowEmailForm && !this.state.showedEmailForm;
  },
  getContainerNode: function getContainerNode(element) {
    if (element) {
      this.containerNode = (0, _reactDom.findDOMNode)(element);
    }
  },
  getWindowListeners: function getWindowListeners() {
    var embedded = this.props.embedded;
    var resizeHandler = embedded ? this.handleResize : (0, _debounce.default)(100, this.handleResize);
    return {
      resize: resizeHandler
    };
  },
  handleResize: function handleResize(e) {
    var forceMobile = this.props.forceMobile;
    var compact = this.state.compact;

    if (forceMobile) {
      return this.handleResizeIFrame();
    }

    if (e.target.innerWidth < COMPACT_BREAKPOINT && !compact) {
      this.setState({
        compact: true
      });
    } else if (e.target.innerWidth >= COMPACT_BREAKPOINT && compact) {
      this.setState({
        compact: false
      });
    }

    return this.handleResizeIFrame();
  },
  getNextIFrameHeight: function getNextIFrameHeight() {
    return this.containerNode.getBoundingClientRect().height + 25;
  },
  handleResizeIFrame: function handleResizeIFrame() {
    if (this.props.embedded && this.containerNode) {
      var height = this.getNextIFrameHeight();
      parent.postMessage({
        height: height
      }, '*');
    }
  },
  getBookingComponent: function getBookingComponent() {
    return this.state.compact ? _CompactBookingPage.default : _FullSizeBookingPage.default;
  },
  renderBookInterface: function renderBookInterface() {
    var _this$props = this.props,
        avatar = _this$props.avatar,
        bookingLifecycle = _this$props.bookingLifecycle,
        formState = _this$props.formState,
        legalConsentEnabled = _this$props.legalConsentEnabled,
        legalConsentResponses = _this$props.legalConsentResponses,
        branding = _this$props.branding,
        canSubmitInitialPropertyForm = _this$props.canSubmitInitialPropertyForm,
        canTroubleshoot = _this$props.canTroubleshoot,
        embedded = _this$props.embedded,
        headline = _this$props.headline,
        isFetchingPublicAvailability = _this$props.isFetchingPublicAvailability,
        profile = _this$props.profile,
        submittingMeeting = _this$props.submittingMeeting,
        DatePickerMarker = _this$props.DatePickerMarker,
        TimePickerMarker = _this$props.TimePickerMarker,
        EmailFormMarker = _this$props.EmailFormMarker;
    var shouldShowEmailForm = this.shouldShowEmailForm();
    var Component = this.getBookingComponent();
    return _react.default.createElement(Component, {
      avatar: avatar,
      bookingLifecycle: bookingLifecycle,
      formState: formState,
      legalConsentEnabled: legalConsentEnabled,
      legalConsentResponses: legalConsentResponses,
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      canTroubleshoot: canTroubleshoot,
      embedded: embedded,
      headline: headline,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      markShowedEmailForm: this.markShowedEmailForm,
      profile: profile,
      shouldShowEmailForm: shouldShowEmailForm,
      submittingMeeting: submittingMeeting,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderPotentialAlert: function renderPotentialAlert() {
    var userMessage = this.props.userMessage;

    if (userMessage) {
      return _react.default.createElement("div", {
        className: "m-all-6"
      }, _react.default.createElement(_UIAlert.default, {
        type: userMessage.type
      }, userMessage.content));
    }

    return null;
  },
  renderCompanyLogo: function renderCompanyLogo() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        embedded = _this$props2.embedded,
        hideLogo = _this$props2.hideLogo;

    if (embedded || hideLogo) {
      return null;
    }

    return _react.default.createElement(_CompanyLogo.default, {
      compact: this.state.compact,
      branding: branding
    });
  },
  renderTroubleshootModeToggle: function renderTroubleshootModeToggle() {
    var _this$props3 = this.props,
        canTroubleshoot = _this$props3.canTroubleshoot,
        troubleshooting = _this$props3.troubleshooting,
        toggleTroubleshootMode = _this$props3.toggleTroubleshootMode;

    if (!canTroubleshoot) {
      return null;
    }

    return _react.default.createElement(_TroubleshootModeToggle.default, {
      compact: this.state.compact,
      canTroubleshoot: canTroubleshoot,
      troubleshooting: troubleshooting,
      toggleTroubleshootMode: toggleTroubleshootMode
    });
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "meetings-page",
      ref: this.getContainerNode
    }, this.renderCompanyLogo(), this.renderTroubleshootModeToggle(), this.renderPotentialAlert(), this.renderBookInterface());
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    canSubmitInitialPropertyForm: (0, _AutoSubmitSelector.canSubmitInitialPropertyForm)(state),
    canTroubleshoot: (0, _TroubleshootingSelectors.canTroubleshootSelector)(state),
    embedded: state.embedded,
    forceMobile: state.forceMobile,
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    isSalesStarter: state.isSalesStarter,
    shouldShowEmailForm: (0, _BookInfoSelectors.shouldShowEmailForm)(state),
    troubleshooting: state.troubleshooting,
    userMessage: state.userMessage,
    bookingLifecycle: state.bookingLifecycle,
    formState: state.formState,
    legalConsentEnabled: (0, _BookInfoSelectors.getLegalConsentEnabled)(state),
    legalConsentResponses: (0, _LegalConsentFormSelectors.getLegalConsentResponses)(state)
  };
}, (0, _extends2.default)({}, BookActions, FormActions, UIActions))(Booking);

exports.default = _default;
module.exports = exports.default;